<template>
    <div class="shop_register">
        <header-section :subnav_show="false" :change_color="true"></header-section>
        <div class="shop_login_bg">
            <div class="shop_login_block width_center_1200">
                <div class="login_right">
                    <div class="login_block">
                        <div class="login_title">
                            <ul>
                                <li class="colors">注册账号</li>
                                <li>|</li>
                                <li @click="$router.push('/user/login')" class="login">账号登录</li>
                            </ul>
                        </div>
                        <div class="login_input">
                            <div class="input_block"><el-input v-model="info.username" type="text" placeholder="用户名" /></div>
                            <div class="input_block">
                                <el-input v-model="info.password" :type="passwordflag?'text':'password'" placeholder="密码">
                                    <span slot="suffix" @click="passwordflag = !passwordflag">
                                        <img src="@/static/img/public/open.png" v-if="passwordflag" alt="" />
                                        <img src="@/static/img/public/close.png" v-else alt="" />
                                    </span>
                                </el-input>
                            </div>
                            <div class="input_block"><el-input v-model="info.realName" type="text" placeholder="真实姓名" /></div>
                            <!-- <div class="input_block gender">
                                <el-select v-model ="info.gender" placeholder="性别" style="width:100%;color:#000">
                                    <el-option :value="0" label="男"></el-option>
                                    <el-option :value="1" label="女"></el-option>
                                </el-select>
                            </div> -->
                            <div class="input_block" style="display:flex;justify-content:flex-start;align-items:center">
                                <el-input v-model="info.mobile" type="text" placeholder="手机号" style="width:200px" />
                                <el-button type="success" @click="getCode">发送验证码</el-button>
                            </div>
                            <div class="input_block">
                                <el-input v-model="info.code" type="text" placeholder="验证码" />
                            </div>
                            <!-- <div class="input_block"><el-input v-model="info.email" type="text" placeholder="邮箱" /></div> -->

                            <!-- <div class="input_block"><input v-model="info.repeatPassword" type="password" placeholder="确认密码"></div>
                            <div class="input_block"><input v-model="info.code" type="text" class="yzm" placeholder="短信验证码">
                                <input style="background: #052bfb;" v-show="show" class="send" type="button" @click="send_sms()" value="发送验证码" />
                                <button style="background: #052bfb;" v-show="!show" class="send" >{{count}}s后重新发送</button>
                            </div> -->
                        </div>
                        <div class="login_btn" @click="to_register" style="cursor:pointer">
                            马上注册
                        </div>

                        <!-- <div class="login_btn_b">
                            <router-link to="/user/forget_password">忘记密码？</router-link>
                        </div> -->

                        <!-- <el-divider>其他登录方式</el-divider>
                        <div class="other_login">
                            <ul>
                                <li><i class="icon iconfont" style="color:#50b674">&#xe73b;</i></li>
                                <li><i class="icon iconfont" style="color:#06b4fd">&#xe60b;</i></li>
                            </ul>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <footer-section></footer-section>
    </div>
</template>

<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
export default {
    components: {
        HeaderSection,
        FooterSection,
    },
    props: {},
    data() {
      return {
        login_adv:"../../static/img/bg/login-bg.jpg",
          info:{
              id:'',
              realName:'',
              username:'',
              mobile:'',
              email:'',
              password:'',
              gender: '',
              code: ''
          },
          show: true,
          count: '',
          timer: null,
          passwordflag: false
      };
    },
    watch: {},
    computed: {},
    methods: {
        // 发送短信
        send_sms:function(){
            if(this.$isEmpty(this.info.mobile)){
                return this.$message.error('请先填写手机号码');
            }
            this.$post(this.$api.userRegCaptcha,{mobile:this.info.mobile}).then(res=>{
                if(res.errno == 0){
                    return this.$message.success(res.msg);
                }else{
                    return this.$message.error(res.msg);
                }
            });
            //倒计时
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }
        },
        async to_register(){
            if(this.$isEmpty(this.info.username)){
                this.$message.error('请输入用户名');
                return
            }
            if(this.$isEmpty(this.info.password)){
                this.$message.error('请输入密码');
                return
            }
            if(this.$isEmpty(this.info.realName)){
                this.$message.error('请输入真实姓名');
                return
            }
            if(this.$isEmpty(this.info.mobile)){
                this.$message.error('请输入手机号');
                return
            }
            if(this.$isEmpty(this.info.code)){
                this.$message.error('请输入验证码');
                return
            }
            
            let flag = false
            const params={
                mobile:this.info.mobile,
                code: this.info.code
            }
            await this.$post(this.$api.varifycode,JSON.stringify(params)).then(res=>{
                if(res.code === 0){
                    flag = false
                }else{
                    this.$message.error(res.msg)
                    flag = true
                }
            })
            if(!flag){
                const params2 = {
                    id:this.info.id,
                    realName:this.info.realName,
                    username:this.info.username,
                    mobile:this.info.mobile,
                    email:this.info.email,
                    password:this.info.password,
                    gender: this.info.gender,
                    orgId: 0,
                    status: 1,
                    roleIdList: [0],
                    postIdList: [0],
                    superAdmin:0,
                    orgName:'',
                    createTime:''
                }
                this.$post(this.$api.userRegister,params2).then(res=>{
                    if(res.code == 0){
                        this.$message.success('注册成功!');
                        this.$router.push('/user/login');
                    }else{
                        return this.$message.error(res.msg);
                    }
                })
            }
        },
        getCode(){
            if(this.$isEmpty(this.info.mobile)){
                this.$message.error('请输入手机号');
                return
            }
            const params={
                mobile:this.info.mobile
            }
            this.$post(this.$api.sendcode,JSON.stringify(params)).then(res=>{
                if(res.code === 0){
                    this.$message.success("发送成功!");
                }else{
                    this.$message.error(res.msg)
                }
            })
        }

    },
    created() {
        // 邀请人
        if(!this.$isEmpty(this.$route.query.inviter_id)){
            this.inviter_id = this.$route.query.inviter_id;
        }
    },
    mounted() {},
	beforeDestroy() {
		if(this.timer){
			clearInterval(this.timer)
			this.timer = null
		}
	}
};
</script>
<style lang="scss" scoped>
.shop_login_bg{
    width: 100%;
    height: 600px;
    background: url("~@/static/img/bg/login-bg.png");
    background-size: cover;
    position: relative;
}
.login_left{
    float: left;
    width: 50%;
    box-sizing: border-box;
    height: 550px;
}
.login_right{
    position: absolute;
    right: 15vw;
    box-sizing: border-box;
    .login_block{
        width: 400px;
        background: #fff;
        // height: 450px;
        float: right;
        box-sizing: border-box;
        padding: 40px;
        margin-top:40px;
        border-radius: 4px;
        .login_title{
            width: 217px;
            margin:0 auto;
            .login{
                cursor: pointer;
            }
            ul:after{
                clear:both;
                display:block;
                content:'';
            }
            ul li{
                float: left;
                margin-right: 20px;
                font-size: 20px;
                color:#444;
                
            }
            ul li:hover{
                color:#ca151e;
            }
            ul li.colors{
                color:#ca151e;
            }
            ul li:last-child{
                margin-right: 0;
            }
        }
        .login_input{
            margin-top: 30px;
            .input_block{
                margin:12px auto;
                width: 320px;
                input{
                    height: 35px;
                    width: 320px;
                    border:1px solid #e1e1e1;
                    outline:none;
                    padding:0 10px;
                    box-sizing: border-box;
                }
                input.yzm{
                    width: 160px;
                    float: left;
                }
                button,input.send{
                    background: #052bfb;;
                    color:#fff;
                    width: 140px;
                    margin-left: 20px;
                    border: none;
                    height: 33px;
                }
                /deep/ .el-input__suffix-inner{
                    line-height: 32px;
                    img{
                        vertical-align: middle;
                        cursor: pointer;
                        margin-right: 10px;
                    }
                }
            }
        }
        .login_btn{
            color:#fff;
            background: #052bfb;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            margin-top:30px;
            a{
                color:#fff;
            }
        }
        .el-divider__text{
            color:#999;
        }
        .login_btn_b{
            text-align: right;
            font-size: 12px;
            color:#666;
            line-height: 45px;
            a{
                color:#666;
            }
            a:hover{
                color:#ca151e;
            }
        }
        .other_login{
            width: 82px;
            margin:0 auto;
            ul li{
                float: left;
                margin-right: 20px;
                i{
                    font-size: 28px;
                }
            }
            ul li:last-child{
                margin-right: 0;
            }
        }
        
    }
}
.gender /deep/ .el-select .el-input__inner{
    padding-left: 15px;
}
.gender /deep/ .el-select .el-input__inner::placeholder{
    color: #777
}
/deep/ input::placeholder{
color:#999;
}
/deep/ .el-select .el-input__inner{
    padding-left: 10px;
}
  /deep/ input::-webkit-input-placeholder {
    color: #777;
  }
  /deep/ input::-moz-input-placeholder {
    color:#777;
  }
  /deep/ input::-ms-input-placeholder {
    color: #777;
  }
</style>